import { section } from "@/neon";
import disclosure from "@/components/disclosure";

const selectors = {
  disclosure: "[data-disclosure]",
};

section("footer", {
  crossBorder: {},

  onLoad() {
    // Wire up Cross Border disclosures
    const cbSelectors = this.container.querySelectorAll(selectors.disclosure);
    if (cbSelectors) {
      cbSelectors.forEach(selector => {
        const { disclosure: d } = selector.dataset;
        this.crossBorder[d] = disclosure(selector, this.container);
      });
    }
  },

  onUnload() {
    Object.keys(this.crossBorder).forEach(t => {
      this.crossBorder[t].unload();
    });
  },
});
